import {
  LOCALSTORAGE_KEY,
  metaTempleImg,
  orderType,
} from "../../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  dayNameToNumber,
  getImageListFromTemple,
  getOneImageForTemple,
  uid,
} from "../../utils/HelperFunctions";
import ParentView from "../../Views/PrarentView/ParentView";
import dayjs from "dayjs";
import {
  updateCartAction,
  updateTempCartPayloadAction,
} from "../../store/actions/cartAction";
import PrasadDetailsView from "../../Views/Prasad/PrasadDetailsView";
import { getTotalPrasadPrice } from "../../store/actions/prasadAction";
import { getPrasadForTempleWithTempleDetails } from "../../store/actions/prasadAction";
import { getPrasadForTempleList } from "../../store/actions/prasadAction";
import HelmetComponent from "../../components/Shared/HelmetComponent";
import { pageReady } from "../../store/slices/pageViewSlice";
import { getDeviceTypeFromUserAgent } from "../../utils/analyics/analyticsHelper";

function PrasadDetailsScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch: any = useDispatch();
  const [localRestrictionChadavaDate, setLocalRestrictionChadavaDate] =
    useState<string[]>([]);
  const [templePersonalInfo, setTemplePersonalInfo] = useState<any>({});
  const [templeId, setTempleId] = useState<string>("");
  const [prasadList, setprasadList] = useState<any>([]);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [totalPriceDisplay, setTotalPriceDisplay] = useState<number>(0);
  const [totalPriceBreakup, setTotalPriceBreakup] = useState<any>(null);
  const [selectedPrasad, setSelectedPrasad] = useState<any>([]);
  const [isDateTimePicker, setIsDateTimePicker] = useState(false);
  const [filteredprasadList, setFilteredprasadList] = useState<any>([]);
  const [firstSelectedItemDate, setFirstSelectedItemDate] = useState("");
  const [pujaDateAndTime, setPujaDateAndTime] = useState<any>(null);
  const [popupItemAlreadyAddedInCart, setPopupItemAlreadyAddedInCart] =
    useState(false);
  const [itemAddLimitPopUp, setItemAddLimitPopUp] = useState(false);
  const [selectedTempleDetails, setSelectedTempleDetails] = useState<any>(null);
  const { cartInfo } = useSelector((state: any) => state.cart);
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion,
  );
  const [isPrasadPkgOpen, setIsPrasadPkgOpen] = useState<any>(false);
  const [selectedPrasadItem, setSelectedPrasadItem] = useState<any>(null);
  const [isOverLimit, setIsOverLimit] = useState<Boolean>(false);
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
    countryCode = null,
    platformFeeForChadhava,
  } = priceConversionState.priceConversionRate || {};
  const { isLoading } = priceConversionState;

  useEffect(() => {
    try {
      const templeId = location.pathname.split("/")[2];
      if (!templeId) {
        navigate("/prasadTemples");
      }
      setTempleId(templeId);
      dispatch(
        getPrasadForTempleWithTempleDetails(
          templeId,
          false,
          platformFeeForChadhava,
          rate,
        ),
      ).then((res: any) => {
        if (res === undefined || !res?.templeDetails) {
          navigate("/prasadTemples");
        }
        setSelectedTempleDetails(res.templeDetails);
        if (res?.prasadItemArray && res.prasadItemArray?.length > 0) {
          const updatedResponse = res.prasadItemArray.map((item: any) => ({
            ...item,
            count: 0,
            disabled: false,
          }));
          setprasadList(updatedResponse);
        }
      });
    } catch (err: any) {
      navigate("/prasadTemples");
    }
  }, [location.pathname]);

  useEffect(() => {
    const templePersonalInfo =
      selectedTempleDetails && selectedTempleDetails.personalInfo
        ? selectedTempleDetails.personalInfo
        : {};
    setTemplePersonalInfo(templePersonalInfo);
  }, [selectedTempleDetails]);

  const templeProfilePic = () => {
    let imageArrayForTemple =
      templePersonalInfo &&
      templePersonalInfo.media &&
      templePersonalInfo.media.pictures &&
      templePersonalInfo.media.pictures.length
        ? templePersonalInfo.media.pictures
        : [];
    let templeProfilePic = getOneImageForTemple(imageArrayForTemple);
    return templeProfilePic;
  };

  useEffect(() => {
    if (!selectedTempleDetails?.id) return;

    const userInfo = JSON.parse(
      localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}",
    );
    const selectedItems =
      prasadList?.filter((item: any) => item?.count > 0) ?? [];

    const firstSelectedItem = selectedItems[0] ?? null;

    dispatch(
      pageReady({
        User_ID: userInfo?.id ?? "Guest User",
        Prasad_Name:
          firstSelectedItem?.name ??
          selectedTempleDetails?.personalInfo?.name ??
          "",
        Temple_ID: selectedTempleDetails?.id ?? "",
        Temple_Name: selectedTempleDetails?.personalInfo?.name ?? "",
        Prasad_Type: "Temple Prasad",
        Price: totalPrice ?? 0,
        Currency: currencySymbols,
        IsOverseas: isOverseas,
        rate: rate,
        IsPrasad: true,
        Page_Type: "Prasad",
        Listing_Type: "Prasad Detail",
      }),
    );
  }, [selectedTempleDetails?.id, totalPrice, prasadList]);

  const goToBookPujaScreen = () => {
    navigate("/templePujaList/" + templeId);
  };

  const navigateToPujaStepsView = () => {
    navigate("/pujaSteps");
  };
  const navigateToSeeVideoView = () => {
    navigate("/pujaVideo");
  };

  // const handleSetChadhawaPrice = (item: any) => {
  //   const price = item?.count * item?.acctualPrice;
  //   setTotalPrice((prevPrice) => prevPrice + price);
  //   setSelectedPrasad((prev: any) => [item, ...prev]);

  //   setprasadList((prev: any) =>
  //     prev.map((chadhava: any) => (chadhava.id === item.id ? item : chadhava))
  //   );
  // };
  const handleIncrement = (item: any) => {
    if (item?.count === 0 && item?.packages?.length) {
      setIsPrasadPkgOpen(true);
      setSelectedPrasadItem(item);
      return;
    }
    setprasadList((prev: any) =>
      prev.map((_prasad: any) => {
        if (_prasad.id === item.id) {
          const updatedCount = _prasad.count + 1;
          const selPkg = _prasad?.packages?.find(
            (_pkg: any) => _pkg.packageId === _prasad?.selectedPackageId,
          );
          if (
            selPkg &&
            selPkg?.maxLimit &&
            updatedCount > Number(selPkg.maxLimit)
          ) {
            setIsOverLimit(true);
            return _prasad;
          }
          return { ..._prasad, count: updatedCount };
        } else {
          return _prasad;
        }
      }),
    );
  };

  const getCalculateTotalPrice = (items: any[]): number => {
    return items.reduce((total, item) => {
      const itemTotal = item.count * Number(item?.priceInfo?.finalPrice);
      return total + itemTotal;
    }, 0);
  };
  // const getCalculateTotalPriceDisp = (items: any[]): any => {
  //   const chadhavaTotalValue = items.reduce((total, item) => {
  //     const itemTotal = Number(
  //       item.count * Number(item?.priceInfo?.finalPriceOv)
  //     ).toFixed(2);

  //     return Number((total + Number(itemTotal)).toFixed(2));
  //   }, 0);

  //   return chadhavaTotalValue;
  // };
  useEffect(() => {
    if (selectedTempleDetails) {
      dispatch(
        getTotalPrasadPrice(
          prasadList,
          isOverseas,
          selectedTempleDetails?.prasadDelivaryPrice ?? null,
          selectedTempleDetails?.prasadPackagingPrice ?? null,
          selectedTempleDetails?.prasadGoodiesPrice ?? null,
          rate,
        ),
      )
        .then((res: any) => {
          setTotalPriceBreakup(res);
          if (res && res?.finalPrice >= 0) {
            setTotalPrice(res.finalPrice);
            setTotalPriceDisplay(res.finalPrice);
          }
        })
        .catch((err: any) => {});
    }
  }, [prasadList]);

  const preprocessingAndProceedToAddmemberScreen = () => {
    // Open pupup for limiting popup and return from there
    if (
      (cartInfo && cartInfo.length === 6) ||
      (cartInfo && cartInfo.length > 6)
    ) {
      setItemAddLimitPopUp(true);
      return;
    }

    // const formattedDateToSave = getDateFormatedForMUISelection(
    //   pujaDateAndTime?.pujaDate?.toString()
    // );
    // let dateTimeData = {
    //   pujaDate: "",
    //   pujaTime: "",
    // };

    // let cartDataPayload: any = {
    //   id: uid(),
    //   members: [],
    //   selectedChadhvaList: filteredprasadList,
    //   templeDetails: selectedTempleDetails,
    //   pujaDateTime: null,
    //   price: totalPrice,
    //   orderType: orderType.prasad,
    // };
    const id = uid();
    let cartDataPayload: any = {
      id,
      cartId: id,
      membersData: [],
      templeDetails: selectedTempleDetails,
      templeId: selectedTempleDetails?.id,
      pujaDateTime: null,
      orderType: orderType.prasad,
      price: totalPrice,
      localRestrictionChadavaDate: localRestrictionChadavaDate,
      selectedPrasadPackage:
        filteredprasadList?.filter((item: any) => item?.count > 0) ?? [],
      addOnPrasadItems:
        filteredprasadList?.filter((item: any) => item?.count === 0) ?? [],
      tempPriceInfo: {
        finalPrice: totalPrice,
      },
    };

    dispatch(updateTempCartPayloadAction(cartDataPayload)).then(() => {
      navigate(`/checkoutV2/addDevotee`);
    });

    // let newCartData = [];
    // newCartData.push(cartDataPayload);
    // dispatch(updateCartAction(newCartData));
    // navigate("/checkoutV2/addDevotee");
  };

  useEffect(() => {
    setFilteredprasadList(prasadList);
  }, [prasadList]);

  const addPrasadItem = (el: any) => {
    if (localRestrictionChadavaDate?.length > 0) {
      const newDates = localRestrictionChadavaDate.filter((item) =>
        el?.restrictionPrasadDate.includes(item),
      );
      setLocalRestrictionChadavaDate(newDates);
    } else {
      setLocalRestrictionChadavaDate(el?.restrictionPrasadDate);
    }
    handleIncrement(el);
  };
  const [needToSetLocalDate, setNeedToSetLocalDate] = useState(false);
  const handleDecrement = (item: any) => {
    setprasadList((prev: any) =>
      prev.map((chadhava: any) => {
        if (chadhava.id === item.id) {
          const updatedCount = chadhava.count > 0 ? chadhava.count - 1 : 0;
          if (updatedCount === 0 && item?.selectedPackageId) {
            setNeedToSetLocalDate(true);
            return {
              ...chadhava,
              count: updatedCount,
              selectedPackageId: null,
            };
          }
          return { ...chadhava, count: updatedCount };
        } else {
          return chadhava;
        }
      }),
    );
  };

  const getAvilableChadhavaDate = (): string => {
    return (
      "This chadhava item is not available on the given date " +
        localRestrictionChadavaDate?.toString() || ""
    );
  };

  const shouldDisableDate = (date: any): any => {
    const restrictionDate: any = localRestrictionChadavaDate;
    if (
      typeof restrictionDate === "undefined" ||
      restrictionDate?.length === 0
    ) {
      return false;
    }

    const dayNames: string[] = restrictionDate?.filter((item: any) =>
      isNaN(Date.parse(item)),
    );

    const selectedDate = dayjs();
    const twoDaysBeforeSelected = selectedDate.add(3, "day");
    if (date.isBefore(twoDaysBeforeSelected, "day")) {
      return true;
    }

    const specificDates: Date[] = restrictionDate
      ?.filter((item: any) => !isNaN(Date.parse(item)))
      ?.map((dateString: any) => new Date(dateString));
    const disableWeekDays: number[] = dayNames
      ?.map(dayNameToNumber)
      ?.filter((day) => day !== null) as number[];
    const day: number = date.day();
    if (disableWeekDays?.includes(day)) {
      return false;
    }

    return !specificDates?.some(
      (disabledDate) =>
        date?.date() === disabledDate?.getDate() &&
        date?.month() === disabledDate?.getMonth() &&
        date?.year() === disabledDate?.getFullYear(),
    );
  };
  const hostname =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;
  const prasadInfoPath = location.pathname;
  const imgList = getImageListFromTemple(
    selectedTempleDetails?.personalInfo,
    "prasadPictures",
  );

  const handleSelectPrasadPkg = (pkgId: any, selectedPrasad: any) => {
    setprasadList((prev: any) =>
      prev.map((prsd: any) => {
        if (prsd.id === selectedPrasad.id) {
          const updatedCount = prsd.count + 1;
          const selPkg = prsd?.packages?.find(
            (_pkg: any) => _pkg.packageId === pkgId,
          );
          if (
            selPkg &&
            selPkg?.maxLimit &&
            updatedCount > Number(selPkg.maxLimit)
          ) {
            setIsOverLimit(true);
            return prsd;
          }
          return {
            ...prsd,
            count: updatedCount,
            selectedPackageId: pkgId,
            priceInfo: selPkg?.priceInfo ?? null,
          };
        } else {
          return prsd;
        }
      }),
    );
  };

  return (
    <ParentView>
      <HelmetComponent
        metaData={{
          title:
            selectedTempleDetails?.prasadMetaData?.metaTitle ??
            selectedTempleDetails?.personalInfo?.name ??
            "Temple" + " | TempleDekho",
          keywords: selectedTempleDetails?.prasadMetaData?.metaKeys ?? null,
          robots: "index, follow",
          description:
            selectedTempleDetails?.prasadMetaData?.metaDescription ??
            selectedTempleDetails?.personalInfo?.descriptions,
          url: hostname + prasadInfoPath,
          imageUrl: imgList?.length ? imgList[0]?.pictureUrl : metaTempleImg,
        }}
      >
        <PrasadDetailsView
          templeDetails={selectedTempleDetails}
          templePersonalInfo={templePersonalInfo}
          goToBookPujaScreen={goToBookPujaScreen}
          templeProfilePic={templeProfilePic}
          navigateToPujaStepsView={navigateToPujaStepsView}
          navigateToSeeVideoView={navigateToSeeVideoView}
          prasadList={prasadList}
          selectedPrasad={selectedPrasad}
          totalPrice={totalPrice}
          isDateTimePicker={isDateTimePicker}
          setIsDateTimePicker={setIsDateTimePicker}
          pujaDateAndTime={pujaDateAndTime}
          setPujaDateAndTime={setPujaDateAndTime}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          filteredprasadList={prasadList}
          preprocessingAndProceedToAddmemberScreen={
            preprocessingAndProceedToAddmemberScreen
          }
          shouldDisableDate={shouldDisableDate}
          firstSelectedItemDate={firstSelectedItemDate}
          getAvilableChadhavaDate={getAvilableChadhavaDate}
          addPrasadItem={addPrasadItem}
          cartInfo={cartInfo}
          popupItemAlreadyAddedInCart={popupItemAlreadyAddedInCart}
          setPopupItemAlreadyAddedInCart={setPopupItemAlreadyAddedInCart}
          currencySymbols={"₹"}
          totalPriceDisplay={totalPriceDisplay}
          isOverseas={isOverseas}
          isCountryDisabledForBooking={
            countryCode === null || countryCode !== "IN" ? true : false
          }
          isLoading={isLoading}
          itemAddLimitPopUp={itemAddLimitPopUp}
          setItemAddLimitPopUp={setItemAddLimitPopUp}
          selectedPrasadItem={selectedPrasadItem}
          isPrasadPkgOpen={isPrasadPkgOpen}
          setIsPrasadPkgOpen={setIsPrasadPkgOpen}
          setSelectedPrasadItem={setSelectedPrasadItem}
          handleSelectPrasadPkg={handleSelectPrasadPkg}
          isOverLimit={isOverLimit}
          setIsOverLimit={setIsOverLimit}
          totalPriceBreakup={totalPriceBreakup}
        />
      </HelmetComponent>
    </ParentView>
  );
}

export default PrasadDetailsScreen;
